import { Injectable } from '@angular/core';

export class IAppSettings {
    apiBaseUrl?: string;
}

@Injectable({
    providedIn: 'root',
})

export class AppSettings {
    static configuration: IAppSettings;

    static get settings() {
        return AppSettings.configuration;
    }
}

export const settings = (): IAppSettings => {
    return AppSettings.configuration;
};
